import {
    SettingScopes,
    UserNotificationState,
    FieldType,
    AttributeType,
    OrderInquiryType,
    TicketAccountType,
    EmailPart,
    FilterPermission,
    ContactViewType,
    TicketPriority,
    ContactStatus,
    ContactAccountType,
    SpecialRateStatus,
    PartnerContactTermStatus,
    DocumentType,
    ActivityCategory,
    MonthStatus as MonthStatusType,
} from '../shared/service-proxies/service-proxies';

export class AppTimezoneScope {
    static Application: number = SettingScopes._1;
    static Tenant: number = SettingScopes._2;
    static User: number = SettingScopes._4;
}

export class AppUserNotificationState {
    static Unread: number = UserNotificationState._0;
    static Read: number = UserNotificationState._1;
}
export enum AppFieldTypes {
    Textbox = FieldType._0,
    Checkbox = FieldType._1,
    RadioButton = FieldType._2,
    Dropdown = FieldType._3,
    Datepicker = FieldType._4,
}

export enum AppAttributeTypes {
    Order = AttributeType._0,
    Provider = AttributeType._1,
    Partner = AttributeType._2,
}

export enum AppOrderInquiryTypes {
    OrderSupport = OrderInquiryType._1,
    CommissionInquiry = OrderInquiryType._2,
}

export enum AppUserContactTypeEnum {
    Mobile = 1,
    Home = 2,
    Business = 3,
    Fax = 4,
}

export enum MyActivityViewTypeEnum {
    SUPPORT = 1,
    SALES = 2,
    MANAGER = 3,
}

export enum TicketAccountTypeEnum {
    Customer = TicketAccountType._0,
    Location = TicketAccountType._1,
    Product = TicketAccountType._2,
    Provider = TicketAccountType._3,
    Commission = TicketAccountType._4,
    Partner = TicketAccountType._5,
    Quote = TicketAccountType._6,
    Order = TicketAccountType._7,
}

export enum EmailFilterPartEnum {
    Subject = EmailPart._1,
    Description = EmailPart._2,
    Sender = EmailPart._3,
    Headers = EmailPart._4,
}

export enum EmailFilterPermissionEnum {
    Allow = FilterPermission._1,
    Deny = FilterPermission._2,
}

export enum ContactStatusEnum {
    Lead = ContactStatus._0,
    Prospect = ContactStatus._1,
    Active = ContactStatus._2,
    Lost = ContactStatus._3,
    Inactive = ContactStatus._4,
}

export enum ContactAccountTypeEnum {
    Provider = ContactAccountType._1,
    Customer = ContactAccountType._2,
    Location = ContactAccountType._3,
    Advisor = ContactAccountType._5,
    AppDirect = ContactAccountType._6,
}

export enum ContactViewTypeEnum {
    MicroCorp = ContactViewType._1,
    Provider = ContactViewType._2,
    Partner = ContactViewType._3,
}

export enum TicketPriorityEnum {
    Low = TicketPriority._0,
    Medium = TicketPriority._1,
    High = TicketPriority._2,
    Urgent = TicketPriority._3,
}

export enum CategorySelectionDisplayMode {
    None = 0,
    All = 1,
    ByCategory = 2,
}

export enum AdditionalReportTabEnum {
    SalesTab = 0,
    CommissionTab = 1,
    AccountingTab = 2,
}

export enum SpecialRateStatusEnum {
    Disabled = SpecialRateStatus._0,
    Enabled = SpecialRateStatus._1,
    EnabledReadonly = SpecialRateStatus._2,
}

export enum PartnerContactTermStatusEnum {
    Invalid = PartnerContactTermStatus._0,
    Current = PartnerContactTermStatus._1,
    Archived = PartnerContactTermStatus._2,
}

export enum DocumentTypeEnum {
    Order = DocumentType._0,
    Quote = DocumentType._1,
    Provider = DocumentType._2,
    Partner = DocumentType._3,
    Customer = DocumentType._4,
    CustomerLocation = DocumentType._5,
    User = DocumentType._6,
    Ticket = DocumentType._7,
    Opportunity = DocumentType._8,
    PartnerDevelopment = DocumentType._9,
}

export enum MonthStatus {
    Unknown = MonthStatusType._0,
    NotOpened = MonthStatusType._1,
    Opened = MonthStatusType._2,
    Reviewed = MonthStatusType._3,
    Locked = MonthStatusType._4,
    AdjustmentsGenerated = MonthStatusType._5,
    PayoutSent = MonthStatusType._6,
    Closed = MonthStatusType._7,
}

export class BsModalCustomSize {
    static FullWidth: string = 'modal-full-screen';
    static ThreeQuartersWidth: string = 'modal-three-quarters-screen';
    static HalfWidth: string = 'modal-half-screen';
}

export enum CreateOrderWidgetDisplayEnum {
    Show = 1,
    ShowFromDuplicateOrder = 2,
    ShowFromQuote = 3,
    ShowFromTicket = 4,
}

export enum CreateEditQuoteModalDisplayEnum {
    Show = 1,
    ShowFromTicket = 2,
}

export class EnumEx {
    static getNamesAndValues<T extends number>(e: any) {
        return EnumEx.getNames(e).map((n) => ({ name: n, value: e[n] as T }));
    }

    static getNames(e: any) {
        return EnumEx.getObjValues(e).filter((v) => typeof v === 'string') as string[];
    }

    static getValues<T extends number>(e: any) {
        return EnumEx.getObjValues(e).filter((v) => typeof v === 'number') as T[];
    }

    private static getObjValues(e: any): (number | string)[] {
        return Object.keys(e).map((k) => e[k]);
    }
}

export const DEFAULT_QUOTE_FILTER_STAGETYPES = '1,2,3,4,5,6';

export const DEFAULT_ORDER_FILTER_STATUSTYPES = '0';


export enum ActivityCategoryEnum {
    Note = ActivityCategory._1,
    Email = ActivityCategory._2,
    FollowUp = ActivityCategory._3,
    Activity = ActivityCategory._4,
}

export enum AdjustmentScheduleTypeEnum {
    PayToZero = 1,
    PayToTerm,
    PayPercentCommission,
}
